import React, { Component } from 'react';
import axios from 'axios';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import './qnaFilter.css';
import cloneDeep from 'lodash/cloneDeep';
import queryString from 'querystring';
import Stomp from 'stompjs';
import {
  EVENT_ID,
  MQ_URL,
  QNA_API_URL,
  TOPIC_QNA_APPROVE,
  TOPIC_QNA_REG,
  TOPIC_QNA_SELECT,
  TOPIC_SESSION_CLOSE,
  TOPIC_SESSION_START,
} from '../constants';

import Amplify from 'aws-amplify';
import awsconfig from '../aws-exports';

import { Button } from '@material-ui/core';

import QnaComponent from './qnaComponent';

Amplify.configure(awsconfig);

class QnaFilter extends QnaComponent {
  constructor(props) {
    super(props);

    let param = queryString.parse(this.props.location.search.replace('?', ''));
    //console.log(param);

    this.state = {
      channelId: param.ch,
      qnaList: [],
    };

    this.getQnAList = this.getQnAList.bind(this);
    this.callFunc = this.callFunc.bind(this);
  }

  callFunc(value) {
    /*
    if (this.state.session && this.state.session.id) {
      this.getQnAList(this.state.session.id);
    }
    */
    this.getQnAList('1');
  }

  getQnAList(pgmId) {
    if (!pgmId) {
      return;
    }
    //console.log(`${QNA_API_URL}/qna/list?channel=${this.state.channelId}&eventId=${EVENT_ID}&pgmId=${pgmId}`);
    axios
      .get(`${QNA_API_URL}/qna/list?channel=${this.state.channelId}&eventId=${EVENT_ID}&pgmId=${pgmId}`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        response.data.Items.sort(function (a, b) {
          return a.id < b.id ? 1 : -1;
        });
        let buffs = [];
        for (let i = 0; i < response.data.Items.length; i++) {
          let data = response.data.Items[i];
          if (data.qna_status === 'S') {
            data.qna_status = 'A';
          }
          buffs.push(data);
        }

        this.setState({
          qnaList: buffs,
        });
      });
  }

  componentWillUnmount() {
    this.customComponentWillUnmount();
  }

  componentDidMount() {
    this.setCallbackFunc(this.callFunc);
    this.customComponentDidMount();

    const clientId = 'qna-admin-' + Math.floor(Math.random() * 100000 + 1);

    const headers = {
      login: 'atozsoft',
      passcode: 'atozsoft0901',
      'client-id': clientId,
    };
    const CH = this.state.channelId;
    const client = Stomp.client(MQ_URL);
    client.connect(
      headers,
      () => {
        console.log('<< connect', new Date());

        client.subscribe(
          '/topic/' + EVENT_ID + '_' + CH,
          (data) => {
            console.log(data);
            if (data.command === 'MESSAGE') {
              let cData = JSON.parse(data.body);
              cData = cData.status;
              switch (cData) {
                case TOPIC_QNA_REG:
                  this.getQnAList('1');
                  break;
                case TOPIC_QNA_APPROVE:
                  break;
                case TOPIC_QNA_SELECT:
                  break;
                case TOPIC_SESSION_START:
                  break;
                case TOPIC_SESSION_CLOSE:
                  break;
                default:
                  break;
              }
            }
          },
          headers,
        );
      },
      function () {
        console.log('error', new Date());
      },
    );

    this.getQnAList('1');
    setInterval(() => {
      this.getQnAList('1');
    }, 10000);
  }
  render() {
    const onChangeQnaState = (data) => {
      data.channel = this.state.channelId;
      axios.put(`${QNA_API_URL}/qna/status`, data).then((response) => {
        if (response.status === 200) {
          let buff = cloneDeep(this.state.qnaList);
          for (let i = 0; i < buff.length; i++) {
            if (buff[i].id === data.qnaId) {
              buff[i].qna_status = response.data.Attributes.qna_status;
              break;
            }
          }

          this.setState({
            qnaList: buff,
          });
        }
      });
    };

    const mapToComponent = (datas) => {
      return datas.map((qna, i) => {
        return (
          <li key={i}>
            <QnaItem qna={qna} onChangeQnaState={onChangeQnaState} />
          </li>
        );
      });
    };

    const onResetList = () => {
      console.log('RESET LIST');
      let buff = '';
      for (let i = 0; i < this.state.qnaList.length; i++) {
        // eslint-disable-next-line
        if (i != 0) {
          buff += ',';
        }
        buff += this.state.qnaList[i].id;
      }

      let param = { resetList: buff, eventId: EVENT_ID };

      console.log(param);

      axios.put(`${QNA_API_URL}/qna/reset`, param).then((response) => {
        console.log(response);
        this.getQnAList('1');
      });
    };

    return (
      <div>
        <h1 style={{ textAlign: 'center' }}>Q&A Administrator</h1>

        <div style={{ padding: '10px 40px', display: 'flex' }}>
          <div style={{ flex: '1' }}>
            {/*<div>
              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '110px' }}>
                <span> 현재시간 : {!this.state.now || this.displayTime(this.state.now)}</span>
                <span> Session : {!this.state.session || this.state.session.pgTitle}</span>
                <span>
                  {' '}
                  Time : {!this.state.session || this.state.session.startTime} ~ {!this.state.session || this.state.session.endTime}
                </span>
              </div>
            </div>
            */}
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={onResetList}
            style={{
              marginRight: '160px',
              width: '100px',
              height: '37px',
              fontSize: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px',
            }}
          >
            초기화
          </Button>
        </div>

        <ul style={{ overflow: 'auto', height: '75vh', marginBottom: '50px' }}>{mapToComponent(this.state.qnaList)}</ul>
      </div>
    );
  }
}

class QnaItem extends Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
    //console.log(props);
  }

  render() {
    const handleChange = (event) => {
      // console.log(event.target.value);
      const value = event.target.value;
      let param = { qnaId: this.props.qna.id, eventId: EVENT_ID, status: value };
      //console.log(param);
      this.props.onChangeQnaState(param);
    };

    return (
      <div className="qna_filter_row">
        <div style={{ flex: '1', fontSize: '24px' }}>
          <div>
            <span style={{ color: '#377ac6' }}>Q. </span>
            {this.props.qna.q}
          </div>
          {/*<div style={{ marginLeft: '20px' }}>{this.props.qna.a ? this.props.qna.a : '답변 미입력'}</div>*/}
        </div>
        <div className="limit_item">{this.props.qna.user}</div>
        <div className="limit_item">
          {this.props.qna.qna_status === 'S' ? (
            '선택중'
          ) : (
            <Select value={this.props.qna.qna_status} onChange={handleChange}>
              <MenuItem value={'R'}>등록</MenuItem>
              <MenuItem value={'A'}>승인</MenuItem>
            </Select>
          )}
        </div>
      </div>
    );
  }
}

export default QnaFilter;
